import * as React from 'react';

import Clock140 from './Clock140';

export const clock140 = () => <Clock140 />;

export default {
    title: 'Illustration/Clock140',
    component: Clock140,
    parameters: {
        notes: "`import Clock140 from 'box-ui-elements/es/illustration/Clock140';`",
    },
};
